import {Component, Injectable, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";

import {ModalBase} from "../../../services/modal/modal-base";

import {CloudApiService} from "../../../services/cloud-api.service";
import {LibraryGroupDto} from "../../../services/dtos/library-group.dto";
import {UserSessionService} from "../../../services/user-session.service";

enum State {
    None,
    Loading,
    Ready
}

@Component({
    selector: 'select-library-modal',
    template: require('./select-library.modal.component.html'),
    styles: [ require('./select-library.modal.component.css') ]
})
export class SelectLibraryModalComponent implements OnInit {

    states = State;
    state: State = State.None;
    errorMessage: string;
    libraries: LibraryGroupDto[] = [];

    searchLibrary: any;

    constructor(
        public activeModal: NgbActiveModal,
        private userSession: UserSessionService,
        private cloudApiService: CloudApiService
    ) {}

    ngOnInit(): void {
        this.state = State.Loading;
        this.cloudApiService.getLibraries()
            .subscribe(
                libraries => {
                    this.libraries = libraries;
                    this.state = State.Ready;
                },
                error => {
                    this.errorMessage = error;
                    this.state = State.None;
                }
            );
    }

    selectLibrary(library: LibraryGroupDto): void {
        this.userSession.setLibrary(library);
        this.activeModal.close();
    }
}

@Injectable()
export class SelectLibraryModal extends ModalBase {
    constructor(modalService: NgbModal) {
        super(modalService, SelectLibraryModalComponent)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/modals/select-library/select-library.modal.component.ts